import {connect} from "react-redux"
import State from "../../../models/State"
import {setFreeTextFilterSearch} from "../../../ducks/search"

export const mapStateToProps = (state: State) => {
    const {freeTextFiltersList, freeTextFilterSearch} = state.search

    return {
        freeTextFiltersList,
        freeTextFilterSearch,
    }
}

export const mapDispatchToProps = (dispatch: any) => ({
    setFreeTextFilterSearch: (e: React.SyntheticEvent, filterName: string) => {
        const {value} = e.target as HTMLInputElement
        dispatch(setFreeTextFilterSearch({filterName, value}))
    },
    clearFreeTextSearchForFilter: (filterName: string) => {
        dispatch(setFreeTextFilterSearch({filterName, value: ""}))
    },
})

export default connect(mapStateToProps, mapDispatchToProps)
